import { Box, Divider, Typography } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";
import DatasetIcon from "../../../../../../assets/TailoredGeneration/icons/training_summary/dataset-icon.svg";
import ModelIcon from "../../../../../../assets/TailoredGeneration/icons/training_summary/model-icon.svg";
import TimeClockIcon from "../../../../../../assets/TailoredGeneration/icons/training_summary/time-icon.svg";
import { useAppStore } from "../../../../../../hooks/useStores.tsx";
import styles from "./TrainingSetupSummary.module.scss";

export const TrainingSetupSummary: React.FC = () => {
	const { t } = useTranslation("tg", { keyPrefix: "models.create.trainingSetupSummary" });
	const { tgStore } = useAppStore();
	const { tgDatasetStore } = tgStore;
	const datasetImageCount =
		tgDatasetStore.datasetForm.upload_type === "advanced"
			? tgDatasetStore.advancedDatasetImages.total_count
			: tgDatasetStore.datasetForm.images.length;

	return (
		<Box className={styles.container}>
			<Box className={styles.section}>
				<img src={DatasetIcon} width={20} height={20} />
				<Typography className={styles.label}>
					{t("datasetLabel")}
					<span className={styles.valueText}>{`${datasetImageCount} ${t("datasetImages")}`}</span>
				</Typography>
			</Box>
			<Divider className={styles.divider} orientation={"vertical"} />
			<Box className={styles.section}>
				<img src={TimeClockIcon} width={20} height={20} />
				<Typography className={styles.label}>
					{t("trainingTimeLabel")}
					<span className={styles.valueText}>{t("trainingTimeText")}</span>
				</Typography>
			</Box>
			<Divider className={styles.divider} orientation={"vertical"} />
			<Box className={styles.section}>
				<img src={ModelIcon} width={20} height={20} />
				<Typography className={styles.label}>
					{t("modelLabel")}
					<span className={styles.valueText}>{t("modelText")}</span>
				</Typography>
			</Box>
		</Box>
	);
};
